import React, { useEffect, useRef, useState } from 'react';
import FacilityTourStyles from './FacilityTour.styled';
import App from '../../App';
import { parseInitialPropsContext } from '../../utils';
import * as dealerService from '../../services/dealerService';
import * as homesService from '../../services/homesService';
import { formatDealerName } from '../Shared/SmokeyTransitional/utils/formatters';
import {
  LazyLoadImage,
  LazyLoadComponent,
} from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import WilsonartImage from '../../images/facility-tour/wilsonart-logo.png';
import FrigidaireImage from '../../images/facility-tour/frigidaire-logo.png';
import HunterImage from '../../images/facility-tour/hunter-logo.png';
import CertainTeedImage from '../../images/facility-tour/certainteed-logo.png';
import CongoleumImage from '../../images/facility-tour/congoleum-logo.png';
import DuraCraftImage from '../../images/facility-tour/duracraft-logo.png';
import NorbordImage from '../../images/facility-tour/norbord-logo.png';
import HuntingtonBrassImage from '../../images/facility-tour/huntingtonbrass-logo.png';
import CemplankImage from '../../images/facility-tour/cemplank-logo.png';
import ShawImage from '../../images/facility-tour/shaw-logo.png';
import GeorgiaPacificImage from '../../images/facility-tour/gp-logo.png';
import LPImage from '../../images/facility-tour/lp-logo.png';
import MoenImage from '../../images/facility-tour/moen-logo.png';
import FormicaImage from '../../images/facility-tour/formica-logo.png';
import KitchenImage from '../../images/facility-tour/square-kitchen@2x.jpg';
import LivingRoomImage from '../../images/facility-tour/square-living-room@2x.jpg';
import BathroomImage from '../../images/facility-tour/square-bathroom@2x.jpg';
import IBeamsImage from '../../images/facility-tour/i-beams@2x.jpg';
import WeldImage from '../../images/facility-tour/weld@2x.jpg';
import InsulationImage from '../../images/facility-tour/insulation@2x.jpg';
import VaporBarrierImage from '../../images/facility-tour/vapor-barrier@2x.jpg';
import TubesImage from '../../images/facility-tour/tubes@2x.jpg';
import PexImage from '../../images/facility-tour/pex@2x.jpg';
import DeckingImage from '../../images/facility-tour/decking@2x.jpg';
import SandingImage from '../../images/facility-tour/sanding@2x.jpg';
import WallInsulationImage from '../../images/facility-tour/wall-insulation@2x.jpg';
import SteelPlatesImage from '../../images/facility-tour/steel-plates@2x.jpg';
import ShinglesImage from '../../images/facility-tour/shingles@2x.jpg';
import BeamImage from '../../images/facility-tour/beam@2x.jpg';
import RoofInsulationImage from '../../images/facility-tour/roof-insulation@2x.jpg';
import SidingImage from '../../images/facility-tour/siding@2x.jpg';
import HouseWrapImage from '../../images/facility-tour/house-wrap@2x.jpg';
import InspectorImage from '../../images/facility-tour/inspector@2x.jpg';
import LessWasteImage from '../../images/facility-tour/less-waste@2x.jpg';
import EshBoardImage from '../../images/facility-tour/esh-board-march-27@2x.png';
import EnergySmartHomeLogoBlue from '../../images/facility-tour/energy-smart-home-logo-blue.png';
import MobileEshImage from '../../images/facility-tour/mobile-esh@2x.png';
import EnergyGraph from '../../images/facility-tour/energy-graph.png';
import CrawlspaceImage from '../../images/facility-tour/crawlspace@2x.jpg';
import EngineeredSystemsImage from '../../images/facility-tour/engineered-systems@2x.jpg';
import SepticImage from '../../images/facility-tour/septic@2x.jpg';
import FootersImage from '../../images/facility-tour/footers@2x.jpg';
import DecksImage from '../../images/facility-tour/decks@2x.jpg';
import HomeConstructionImage from '../../images/facility-tour/home-construction@2x.jpg';
import { Helmet } from 'react-helmet';

const FacilityTour = ({ dealer, homes }) => {
  const backToTop = useRef(null);
  const [cdTopClasses, setCdTopClasses] = useState('cd-top');
  const [scrollOffset, setOffset] = useState(0);
  const [navOpen, setNavOpen] = useState(false);

  const dealerFriendlyName = formatDealerName(
    dealer.dealerName || 'Clayton Homes'
  );

  // browser window scroll (in pixels) after which the "back to top" link is visbible
  const offset = 300;

  // browser window scroll (in pixels) after which the "back to top" link opacity is reduced
  const offset_opacity = 1200;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.onscroll = () => {
        setOffset(window.pageYOffset);
      };
    }
  }, []);

  useEffect(() => {
    scrollOffset > offset
      ? setCdTopClasses('cd-top cd-is-visible')
      : setCdTopClasses('cd-top');
    if (scrollOffset > offset_opacity) {
      setCdTopClasses('cd-top cd-is-visible cd-fade-out');
    }
  }, [scrollOffset]);

  return (
    <App dealer={dealer} homes={homes}>
      <Helmet>
        <title>Facility Tour | {dealerFriendlyName}</title>
      </Helmet>
      <FacilityTourStyles>
        <a href="#facilityTop" className={cdTopClasses} ref={backToTop}></a>
        <div id="facilityTop" className="facility-tour-header-wrap scrollspy">
          <div className="facility-tour-header-wrap__text-wrap">
            <span className="facility-tour-header-wrap__title">
              Facility Tour
            </span>
            <span className="facility-tour-header-wrap__blurb">
              One of America's Largest{' '}
              <span className="no-wrap">Home Builders</span>
            </span>
            <a
              id="interactiveBtnTop"
              href="/interactive-facility-tour"
              className="interactive-btn"
            >
              View Interactive Tour
            </a>
          </div>
        </div>
        <div
          className="facility-tour-nav-mobile"
          onClick={() => setNavOpen(!navOpen)}
        >
          <div className="nav-dropdown-button-wrap clearfix">
            <a href="#" className="facility-tour-nav-dropdown">
              Menu
            </a>
            <div
              id="facility-tour-menu-chevron"
              className={`dropdown-chevron ${navOpen && 'flip'}`}
            ></div>
          </div>
          <div
            id="dropdown-facility-tour-nav"
            className={`dropdown-facility-tour-content ${
              navOpen ? 'open' : 'closed'
            }`}
          >
            <a
              href="#brands"
              className="facility-tour-nav__option"
              onClick={() => setNavOpen(false)}
            >
              Brands
            </a>
            <a
              href="#foundation"
              className="facility-tour-nav__option"
              onClick={() => setNavOpen(false)}
            >
              Foundation
            </a>
            <a
              href="#subfloor"
              className="facility-tour-nav__option"
              onClick={() => setNavOpen(false)}
            >
              SubFloor
            </a>
            <a
              href="#plumbing"
              className="facility-tour-nav__option"
              onClick={() => setNavOpen(false)}
            >
              Plumbing
            </a>
            <a
              href="#flooring"
              className="facility-tour-nav__option"
              onClick={() => setNavOpen(false)}
            >
              Flooring
            </a>
            <a
              href="#walls"
              className="facility-tour-nav__option"
              onClick={() => setNavOpen(false)}
            >
              Walls
            </a>
            <a
              href="#roofsystem"
              className="facility-tour-nav__option"
              onClick={() => setNavOpen(false)}
            >
              Roof System
            </a>
            <a
              href="#exterior"
              className="facility-tour-nav__option"
              onClick={() => setNavOpen(false)}
            >
              Exterior
            </a>
            <a
              href="#inspections"
              className="facility-tour-nav__option"
              onClick={() => setNavOpen(false)}
            >
              Inspections
            </a>
            <a
              href="#energysmart"
              className="facility-tour-nav__option"
              onClick={() => setNavOpen(false)}
            >
              Energy Smart
            </a>
            <a
              href="#pierandbeam"
              className="facility-tour-nav__option"
              onClick={() => setNavOpen(false)}
            >
              Pier &amp; Beam
            </a>
            <a
              href="#homesite"
              className="facility-tour-nav__option"
              onClick={() => setNavOpen(false)}
            >
              Home Site
            </a>
          </div>
        </div>
        <div className="facility-tour-nav-wrap">
          <div className="facility-tour-nav">
            <a href="#brands" className="facility-tour-nav__option">
              Brands
            </a>
            <a href="#foundation" className="facility-tour-nav__option">
              Foundation
            </a>
            <a href="#subfloor" className="facility-tour-nav__option">
              SubFloor
            </a>
            <a href="#plumbing" className="facility-tour-nav__option">
              Plumbing
            </a>
            <a href="#flooring" className="facility-tour-nav__option">
              Flooring
            </a>
            <a href="#walls" className="facility-tour-nav__option">
              Walls
            </a>
            <a href="#roofsystem" className="facility-tour-nav__option">
              Roof System
            </a>
            <a href="#exterior" className="facility-tour-nav__option">
              Exterior
            </a>
            <a href="#inspections" className="facility-tour-nav__option">
              Inspections
            </a>
            <span className="no-wrap">
              <a href="#energysmart" className="facility-tour-nav__option">
                Energy Smart
              </a>
              <a href="#pierandbeam" className="facility-tour-nav__option">
                Pier &amp; Beam
              </a>
              <a href="#homesite" className="facility-tour-nav__option">
                Home Site
              </a>
            </span>
          </div>
        </div>
        <div className="border-line"></div>
        <div className="facility-tour-content-wrap no-place-like-home">
          <div className="facility-tour-page__blurb">
            <span className="facility-tour-page__blurb__header">
              They say there's no place{' '}
              <span className="no-wrap">like home.</span>
            </span>
            <span className="facility-tour-page__blurb__body">
              Your home is more than four walls and a roof. It's a place to
              build the life you've always wanted. Here at {dealerFriendlyName},
              we never forget that. When you buy from us, you're getting a home
              that means as much to us as it
              <span className="no-wrap"> does to you.</span>
            </span>
          </div>
        </div>
        <LazyLoadComponent>
          <div className="kitchen-hero"></div>
        </LazyLoadComponent>
        <div id="brands" className="facility-tour-content-wrap">
          <div className="brands-wrap clearfix">
            <span className="brands-wrap__title">Quality Brands</span>
            <div className="brands-wrap__logos">
              <div className="brands-wrap__logo">
                <LazyLoadImage
                  alt="Wilsonart Logo"
                  effect="blur"
                  src={WilsonartImage}
                />
              </div>
              <div className="brands-wrap__logo">
                <LazyLoadImage
                  alt="Frigidaire Logo"
                  effect="blur"
                  src={FrigidaireImage}
                />
              </div>
              <div className="brands-wrap__logo">
                <LazyLoadImage
                  alt="Hunter Logo"
                  effect="blur"
                  src={HunterImage}
                />
              </div>
              <div className="brands-wrap__logo">
                <LazyLoadImage
                  alt="CertainTeed Logo"
                  effect="blur"
                  src={CertainTeedImage}
                />
              </div>
              <div className="brands-wrap__logo">
                <LazyLoadImage
                  alt="Congoleum Logo"
                  effect="blur"
                  src={CongoleumImage}
                />
              </div>
              <div className="brands-wrap__logo">
                <LazyLoadImage
                  alt="DuraCraft Logo"
                  effect="blur"
                  src={DuraCraftImage}
                />
              </div>
              <div className="brands-wrap__logo">
                <LazyLoadImage
                  alt="Norbord Logo"
                  effect="blur"
                  src={NorbordImage}
                />
              </div>
              <div className="brands-wrap__logo">
                <LazyLoadImage
                  alt="Huntington Brass Logo"
                  effect="blur"
                  src={HuntingtonBrassImage}
                />
              </div>
              <div className="brands-wrap__logo">
                <LazyLoadImage
                  alt="Cemplank Logo"
                  effect="blur"
                  src={CemplankImage}
                />
              </div>
              <div className="brands-wrap__logo">
                <LazyLoadImage alt="Shaw Logo" effect="blur" src={ShawImage} />
              </div>
              <div className="brands-wrap__logo">
                <LazyLoadImage
                  alt="Georgia Pacific Logo"
                  effect="blur"
                  src={GeorgiaPacificImage}
                />
              </div>
              <div className="brands-wrap__logo">
                <LazyLoadImage alt="LP Logo" effect="blur" src={LPImage} />
              </div>
              <div className="brands-wrap__logo">
                <LazyLoadImage alt="Moen Logo" effect="blur" src={MoenImage} />
              </div>
              <div className="brands-wrap__logo">
                <LazyLoadImage
                  alt="Formica Logo"
                  effect="blur"
                  src={FormicaImage}
                />
              </div>
            </div>
            <div className="brands-wrap__photos clearfix">
              <LazyLoadImage alt="kitchen" effect="blur" src={KitchenImage} />
              <LazyLoadImage
                alt="living room"
                effect="blur"
                src={LivingRoomImage}
              />
              <LazyLoadImage alt="bathroom" effect="blur" src={BathroomImage} />
            </div>
          </div>
        </div>
        <div id="foundation" className="width-wrapper">
          <LazyLoadComponent>
            <div className="foundation-wrap-header">
              <span className="facility-tour-header-wrap__sub-title">
                Foundation
              </span>
            </div>
          </LazyLoadComponent>
          <div className="facility-tour-content-wrap">
            <span className="facility-tour-section__blurb">
              Steel I-beams are engineered to support the structure of
              <span className="no-wrap"> your home.</span>
            </span>
            <div className="facility-tour-section__photo-wrap two-photos clearfix">
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="I-beams"
                  effect="blur"
                  src={IBeamsImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  Cross members connect two I-beams and add stability to your
                  <span className="no-wrap"> home's foundation.</span>
                </span>
              </div>
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Welding"
                  effect="blur"
                  src={WeldImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  Outriggers are welded to the steel I-beam for extra strength{' '}
                  <span className="no-wrap">and support.</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div id="subfloor" className="width-wrapper">
          <LazyLoadComponent>
            <div className="subfloor-wrap-header">
              <span className="facility-tour-header-wrap__sub-title">
                Sub Floor
              </span>
            </div>
          </LazyLoadComponent>
          <div className="facility-tour-content-wrap">
            <span className="facility-tour-section__blurb">
              An engineered floor system provides a solid foundation for your
              flooring, ensuring a solid feel and maximum
              <span className="no-wrap"> sound control.</span>
            </span>
            <div className="facility-tour-section__photo-wrap two-photos clearfix">
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Sub-floor insulation"
                  effect="blur"
                  src={InsulationImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  A thick blanket of quality insulation keeps the home
                  comfortable and{' '}
                  <span className="no-wrap">energy efficient.</span>
                </span>
              </div>
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Vapor barrier"
                  effect="blur"
                  src={VaporBarrierImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  A nylon reinforced vapor barrier adds a layer of protection to
                  keep moisture out of the home and serves as a barrier against
                  pests<span className="no-wrap"> and allergens.</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div id="plumbing" className="width-wrapper">
          <LazyLoadComponent>
            <div className="plumbing-wrap-header">
              <span className="facility-tour-header-wrap__sub-title">
                Plumbing System
              </span>
            </div>
          </LazyLoadComponent>
          <div className="facility-tour-content-wrap">
            <span className="facility-tour-section__blurb">
              Flexible water lines withstand frigid temperatures for peace of
              mind in<span className="no-wrap"> cold climates.</span>
            </span>
            <div className="facility-tour-section__photo-wrap two-photos clearfix">
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Tubes"
                  effect="blur"
                  src={TubesImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  Plumbing is installed within the insulation blanket to help
                  maintain consistent{' '}
                  <span className="no-wrap">water temperatures.</span>
                </span>
              </div>
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Pex Plumbing"
                  effect="blur"
                  src={PexImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  Pex Plumbing is used in your home to maintain constant water
                  pressure and<span className="no-wrap"> prevent leaks.</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div id="flooring" className="width-wrapper">
          <LazyLoadComponent>
            <div className="flooring-wrap-header">
              <span className="facility-tour-header-wrap__sub-title">
                Flooring
              </span>
            </div>
          </LazyLoadComponent>
          <div className="facility-tour-content-wrap">
            <span className="facility-tour-section__blurb">
              Water resistant "no-wax" floor covering is used in kitchens,
              bathrooms,<span className="no-wrap"> and other areas.</span>
            </span>
            <div className="facility-tour-section__photo-wrap two-photos clearfix">
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Decking"
                  effect="blur"
                  src={DeckingImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  Interlocking floor decking keeps the floors{' '}
                  <span className="no-wrap">structurally sound.</span>
                </span>
              </div>
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Sanding"
                  effect="blur"
                  src={SandingImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  Decking is sanded to provide a smooth surface for installing
                  <span className="no-wrap"> floor covering.</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div id="walls" className="width-wrapper">
          <LazyLoadComponent>
            <div className="walls-wrap-header">
              <span className="facility-tour-header-wrap__sub-title">
                Exterior Walls
              </span>
            </div>
          </LazyLoadComponent>
          <div className="facility-tour-content-wrap">
            <span className="facility-tour-section__blurb">
              <b>Built to last</b> - Standard exterior wall construction
              includes studs framed on 16" centers. The door and window openings
              have structural headers for added strength{' '}
              <span className="no-wrap">and functionality.</span>
            </span>
            <div className="facility-tour-section__photo-wrap two-photos clearfix">
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Wall insulation"
                  effect="blur"
                  src={WallInsulationImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  Walls are packed full of thick insulation for maximum{' '}
                  <span className="no-wrap">energy efficiency.</span>
                </span>
              </div>
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Steel plates for safety"
                  effect="blur"
                  src={SteelPlatesImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  Electrical wiring is covered by steel plates where it passes
                  through the wall studs to ensure safety and{' '}
                  <span className="no-wrap">prevent damage.</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div id="roofsystem" className="width-wrapper">
          <LazyLoadComponent>
            <div className="roof-wrap-header">
              <span className="facility-tour-header-wrap__sub-title">Roof</span>
            </div>
          </LazyLoadComponent>
          <div className="facility-tour-content-wrap">
            <span className="facility-tour-section__blurb">
              Engineered Truss System
            </span>
            <div className="facility-tour-section__photo-wrap three-photos clearfix">
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Fiberglass shingles"
                  effect="blur"
                  src={ShinglesImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  Fiberglass shingles are standard with optional architectural{' '}
                  <span className="no-wrap">shingles available.</span>
                </span>
              </div>
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Laminated ridge beam"
                  effect="blur"
                  src={BeamImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  A laminated ridge beam and structural lumber beams are used
                  over all openings between the two sections to maintain the
                  structural integrity of the
                  <span className="no-wrap"> entire home.</span>
                </span>
              </div>
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Roof insulation"
                  effect="blur"
                  src={RoofInsulationImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  Insulation fills the roof cavity reducing
                  <span className="no-wrap"> energy costs.</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div id="exterior" className="width-wrapper">
          <LazyLoadComponent>
            <div className="exterior-wrap-header">
              <span className="facility-tour-header-wrap__sub-title">
                Exterior
              </span>
            </div>
          </LazyLoadComponent>
          <div className="facility-tour-content-wrap">
            <div className="facility-tour-section__photo-wrap two-photos clearfix">
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Siding"
                  effect="blur"
                  src={SidingImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  Durable and low maintenance siding is installed
                  <span className="no-wrap"> by hand.</span>
                </span>
              </div>
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="House wrap"
                  effect="blur"
                  src={HouseWrapImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  House wrap is installed under the siding as a second line of
                  defense to protect your home against the elements and help
                  reduce<span className="no-wrap"> energy bills.</span>
                </span>
                <span className="facility-tour-section__photo-content-small-blurb">
                  Vinyl siding and house wrap are not used at all building
                  facilities. Construction method will vary depending upon
                  geographic region. Applicable federal and state
                  <span className="no-wrap"> code requirements.</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div id="inspections" className="width-wrapper">
          <LazyLoadComponent>
            <div className="inspections-wrap-header">
              <span className="facility-tour-header-wrap__sub-title">
                Inspections
              </span>
            </div>
          </LazyLoadComponent>
          <div className="facility-tour-content-wrap">
            <div className="facility-tour-section__photo-wrap two-photos clearfix">
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Inspector"
                  effect="blur"
                  src={InspectorImage}
                />
                <span className="facility-tour-section__photo-content-blurb blurb-title">
                  Our internal inspections include:
                </span>
                <span className="facility-tour-section__photo-content-blurb">
                  <ul className="facility-tour-section__photo-content-blurb list">
                    <li>
                      Pressure-tested{' '}
                      <span className="no-wrap">plumbing lines</span>
                    </li>
                    <li>Electrical outlets</li>
                    <li>
                      Exterior inspection for consistency
                      <span className="no-wrap"> and quality</span>
                    </li>
                    <li>
                      Thorough walk-through to check walls, doors, trim,
                      <span className="no-wrap"> and flooring</span>
                    </li>
                    <li>And much more...</li>
                  </ul>
                </span>
              </div>
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Less waste"
                  effect="blur"
                  src={LessWasteImage}
                />
                <span className="facility-tour-section__photo-content-blurb blurb-title">
                  Less Waste!
                </span>
                <span className="facility-tour-section__photo-content-blurb sub">
                  Excess building waste is minimized by having exact dimensions
                  and measurements for{' '}
                  <span className="no-wrap">our building materials.</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div id="energysmart" className="width-wrapper">
          <div className="energysmart-wrap-header">
            <LazyLoadImage
              className="esh-image-desktop"
              alt="Energy Smart Home"
              effect="blur"
              src={EshBoardImage}
            />
            <div className="disclaimer-wrap">
              <span className="esh-disclaimer desktop">
                <span className="asterisk-blue">*</span>Some models with vaulted
                ceilings have a max value of R30.
              </span>
            </div>
          </div>
          <div className="energysmart-wrap-header-mobile">
            <LazyLoadImage
              className="esh-logo-mobile"
              alt="Energy Smart Home"
              effect="blur"
              src={EnergySmartHomeLogoBlue}
            />
            <LazyLoadImage
              className="esh-logo-mobile"
              alt="Energy Smart Home"
              effect="blur"
              src={MobileEshImage}
            />
            <div className="disclaimer-wrap">
              <span className="esh-disclaimer mobile">
                <span className="asterisk-blue">*</span>Some models with vaulted
                ceilings have a max value of R30.
              </span>
            </div>
            <ul className="esh-details-mobile">
              <li>Low-E Windows</li>
              <li>Air-tight construction</li>
              <li>R33 Ceiling Insulation*</li>
              <li>Thermo Mate-Line Gasket</li>
              <li>
                Energy Efficient<span className="no-wrap"> Water heater</span>
              </li>
              <li>improved air filtration</li>
              <li>sealed duct work</li>
              <li>R22 floor insulation</li>
              <li>R11 floor insulation</li>
              <li>programmable thermostat</li>
              <li>energy efficient light bulbs</li>
            </ul>
          </div>
          <div className="energysmart-background">
            <div className="facility-tour-content-wrap">
              <div className="energy-smart-wrap clearfix">
                <div className="energy-smart-section-left">
                  <span className="energy-smart-section__headline">
                    Did you Know?
                  </span>
                  <p className="energy-smart-section__body">
                    These energy efficient options are available on most of our
                    models. When compared to older site-built homes, the modern
                    manufactured home is much
                    <span className="no-wrap"> more efficient.</span>
                  </p>
                  <p className="energy-smart-section__body">
                    Homes are built in climate controlled advanced building
                    facilities that protect the home from weather damage &amp;
                    the physical delays of
                    <span className="no-wrap"> site-built construction.</span>
                  </p>
                </div>
                <div className="energy-smart-section-right">
                  <span className="energy-smart-section__headline">
                    Average Household's Energy Consumption{' '}
                    <span className="no-wrap">by Percentage</span>
                  </span>

                  <LazyLoadImage
                    className="energy-graph"
                    alt="Energy Consumption Graph"
                    effect="blur"
                    src={EnergyGraph}
                  />
                  <p className="energy-smart-section__footnote">
                    *Source: 2009 RECS Survey conducted by U.S. Energy
                    Information Administration.
                    http://www.ela.gov/consumption/residential/index.cfm.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="pierandbeam" className="width-wrapper">
          <LazyLoadComponent>
            <div className="pierbeam-wrap-header">
              <span className="facility-tour-header-wrap__sub-title">
                Pier &amp; Beam Foundation
              </span>
            </div>
          </LazyLoadComponent>
          <div className="facility-tour-content-wrap">
            <span className="facility-tour-section__small-blurb">
              Diagram and pictures are for illustration purposes only and actual
              materials used and installation methods may vary based on
              geographic region and installation contractor preferences. All
              home installations are subject to applicable federal and state{' '}
              <span className="no-wrap">code requirements.</span>
            </span>
            <span className="facility-tour-section__blurb">
              Strength &amp; durability are important factors when constructing
              your home, which is why we use a Pier and{' '}
              <span className="no-wrap">Beam Foundation.</span>
            </span>
            <div className="facility-tour-section__photo-wrap two-photos clearfix">
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Crawlspace"
                  effect="blur"
                  src={CrawlspaceImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  Crawlspace area allows easy access to utilities and
                  <span className="no-wrap"> duct work.</span>
                </span>
              </div>
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Engineered Systems"
                  effect="blur"
                  src={EngineeredSystemsImage}
                />
                <span className="facility-tour-section__photo-content-blurb">
                  Engineered systems secure homes to prevent shifting.
                </span>
                <span className="facility-tour-section__photo-content-small-blurb">
                  Diagram and pictures are for illustration purposes only and
                  actual materials used and installation methods may vary based
                  on geographic region and installation contractor preferences.
                  All home installations are subject to applicable federal and
                  state<span className="no-wrap"> code requirements.</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div id="homesite" className="width-wrapper">
          <LazyLoadComponent>
            <div className="homesite-wrap-header">
              <span className="facility-tour-header-wrap__sub-title">
                Home Site
              </span>
            </div>
          </LazyLoadComponent>
          <div className="facility-tour-content-wrap">
            <span className="facility-tour-section__section-title">
              Land Improvement Options
            </span>
            <span className="facility-tour-section__blurb">
              It takes more than a house to create a home. Land improvement
              options complete your home site and make the transition into your
              new home as easy<span className="no-wrap"> as possible.</span>
            </span>
            <div className="facility-tour-section__photo-wrap three-photos clearfix">
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Septic System"
                  effect="blur"
                  src={SepticImage}
                />
                <span className="facility-tour-section__photo-content-blurb-centered">
                  Septic Systems
                </span>
              </div>
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Footers"
                  effect="blur"
                  src={FootersImage}
                />
                <span className="facility-tour-section__photo-content-blurb-centered">
                  Footers
                </span>
              </div>
              <div className="facility-tour-section__photo-content">
                <LazyLoadImage
                  className="facility-tour-section__photo-content-photo"
                  alt="Decks"
                  effect="blur"
                  src={DecksImage}
                />
                <span className="facility-tour-section__photo-content-blurb-centered">
                  Decks &amp; Porches
                </span>
              </div>
            </div>
            <div className="facility-tour-section__photo-section clearfix">
              <LazyLoadImage
                className="facility-tour-section__photo-content-photo"
                alt="Home Site"
                effect="blur"
                src={HomeConstructionImage}
              />
              <div className="facility-tour-section__photo-section-blurb">
                <ul className="facility-tour-section__photo-section-blurb list">
                  <li>Wells</li>
                  <li>Driveways</li>
                  <li>Electrical</li>
                  <li>Septic Systems</li>
                  <li>Decks &amp; Porches</li>
                  <li>Footers</li>
                  <li>And more...</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="bottom-cta">
            <div className="facility-tour-header-wrap__text-wrap">
              <span className="facility-tour-header-wrap__title">
                Interactive Facility Tour
              </span>
              <a
                id="interactiveBtnBottom"
                href="/interactive-facility-tour"
                className="interactive-btn"
              >
                View Interactive Tour
              </a>
            </div>
          </div>
        </div>
      </FacilityTourStyles>
    </App>
  );
};

FacilityTour.getInitialProps = async (ctx) => {
  return await parseInitialPropsContext(ctx, dealerService, homesService).catch(
    (e) => {
      console.error(e);
      return { redirectTo: '/error' };
    }
  );
};

export default FacilityTour;
